<template>
<div>
    <div class="videoWrapper">
        <app-modal v-if="appModal" v-bind:close="handleAppModalClose" />
        <Popup
        v-if="popup.on"
        v-bind:type="popup.type"
        v-bind:title="popup.title"
        v-bind:contents="popup.contents"
        v-bind:option="popup.option"
        v-bind:ok="popup.ok"
        v-bind:cancel="popup.cancel"
        />
        <div class="lobbyContainer">
            <button class="close" @click="closeEntrance()"></button>
            <div class="lobbyContent">
                <div class="logo">COCOcall</div>
                <div class="video" v-bind:class=" offVideo ? 'camOff' : ''">
                    <video ref="video" v-bind:style="offVideo? `display: none` : `display: block`"></video>
                    <div class="button controller">
                        <button class="camera" v-bind:class="offVideo ? 'off' : ''" @click="offVideo = !offVideo"></button>
                        <button class="mic" v-bind:class="offMic ? 'off' : ''" @click="offMic = !offMic"></button>
                    </div>
                    <div class="button" v-if="!isMoblile">
                        <button class="setting" @click="handleSettingBtn()"></button>
                    </div>
                    <div class="userContainer">
                        <div class="user">
                            <span class="name" v-bind:class="offMic ? 'micOff' : ''">{{ name === '' ? '익명' : name }}</span>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="name">
                        <div class="title">이름을 입력해주세요. <span>* 이름을 입력하지 않으면 ‘익명’으로 표시됩니다.</span></div>
                        <div class="input">
                            <input type="text" placeholder="익명" v-on:input="typingName" v-on:keyup.enter="handleStartBtn()" maxlength="8">
                        </div>
                    </div>
                    <div class="button">
                        <button @click="handleStartBtn()">참여하기</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import webRTC from '../commons/webrtc';
import Session from '../commons/session'
import AppModal from '@/components/AppModal';
import Popup from '../components/Popup';
import { eBus } from '../commons/eventBus'
import { sendMessage } from '../commons/message';
import mobile from '../commons/mobile'

export default {
    components: { Popup, AppModal },
    data() {
        return {
            offMic: false,
            offVideo: false,
            name: '',
            popup: {
                on: false,
                type: '',
                title: '',
                contents: '',
                option: {},
                ok: null,
                cancel: null
            },
            appModal : false,
            isMoblile: mobile.isMobile
        };
    },
    async mounted() {
        if (mobile.isMobile && mobile.isNotSupported) {
            this.appModal = true;
            if (!mobile.isSafari){
                //kakao browser -> 앱 설치 or 앱 실행
                let roomId = window.location.href.indexOf('/entrance/') > -1 ? window.location.href.split('/entrance/')[1] : '';
                location.href = `Intent://kp.cococall${roomId !== '' ? `?roomid=${roomId}` : ``}#Intent;scheme=kpoint;package=kr.co.knowledgepoint.knowledgetalkccc;end`;
                return false;
            }
        }
        if (mobile.isMobile && !mobile.isWebView && !mobile.isPlayBrowser) {
            this.appModal = true;
        }
        if (mobile.isMobile && mobile.isWebView) {
            window.mobileBackBtn = mobile.mobileBackBtn;
        }

        if (!this.$store.state.socket) {
            const session = new Session();
            session.connect();   
        }

        if (await webRTC.checkMediaDevices()) {
            let stream = await webRTC.createVideoStream(true);
            let video = document.querySelector('video');
            video.srcObject = stream;
            video.autoplay = true;
            video.muted = true;
            video.playsInline = true;
        }
                
        //모바일 브라우저 뒤로가기 이벤트 :  떠있는 창 끄거나 메인으로
        eBus.$on('mobilebackbtn', () => {
            if (this.popup.on) this.popup.on = false;
            else this.closeEntrance();
        });
        
        eBus.$on('popup-enter', param => {
            this.popup.on = param.on;
            this.popup.type = param.type;
            this.popup.title = param.title;
            this.popup.contents = param.contents;
            this.popup.option = param.option;
            this.popup.ok = param.ok;
            this.popup.cancel = param.cancel;
        });

        if(!mobile.isMobile) document.getElementsByTagName('input')[0].focus();
    },
    beforeDestroy() {
        // 210303 모바일웹 종료 이슈 수정
        this.$refs.video.srcObject = null;
    },
    methods: {
        typingName(e) {
            this.name = e.target.value;
        },
        handleSettingBtn() {
            eBus.$emit('popup-enter', {
                on: true,
                type: 'Settings',
                title: this.$t('popup-setting-devices-title'),
                contents: this.$t('popup-setting-devices-contents-1'),
                option: { inCall: false },
                ok: () => { 
                    eBus.$emit('popup-enter', { on: false });
                    eBus.$emit('setVideo', { //to Video.vue
                        type: 'set',
                        id: 'local',
                        deviceSetting: { done: true } });
                },
                cancel: () => { eBus.$emit('popup-enter', { on: false }) },
            });
        },
        handleStartBtn() {
            if(this.name.trim().length === 0) {
                this.name = '익명';
            }
            sendMessage('RoomJoinWithName', { roomId: window.location.href.split('/entrance/')[1], name: this.name, offVideo: this.offVideo, offMic: this.offMic });
            this.$store.commit('checkEntrance', true);
            this.$store.commit('setUserInfo', { name: this.name });
            this.$store.commit('setVideoStatus', { userId:'local', camOff: this.offVideo, micOff: this.offMic });
            
        },
        closeEntrance() {
            window.location.href = '/';
        },
        handleAppModalClose() {
            this.appModal = false;
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/Entrance.vue